import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { contactAffiliate } from '../ActionsBevego/Affiliates.action';
import Close from '../../images/close.svg';
import ArrowDown from '../../images/bevego/arrow-down.svg';
import ArrowUp from '../../images/bevego/arrow-up.svg';
import { translate } from '../Services/translation';

export const getContactAffiliatePicker = () => {
    return contactAffiliatePicker.length != undefined && contactAffiliatePicker.length > 0 ? contactAffiliatePicker[0] : contactAffiliatePicker;
}

const ContactAffiliatePickerDialog = () => {
    const dispatch = useDispatch();
    const affiliates = useSelector((state) => state.affiliates);

    const [showInfo, setShowInfo] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [newAffiliateId, setNewAffiliateId] = useState(null);
    const [error, setError] = useState(false);

    

    const handleChange = (selectedOption) => {
        let selectedAffiliate = newAffiliateId;
        if (!newAffiliateId){
            selectedAffiliate = affiliates.find(i=>i.selected).id;
        }

        dispatch(contactAffiliate(
            selectedAffiliate,
            getContactAffiliatePicker().dataset.articleNumber))
            .then(() => {
                setError(false);
                setShowConfirm(true);
            })
            .catch((ex) => {
                setError(true);
                setShowConfirm(true);
            });
    };

    const closeConfirmation = () => {
        close();
        setShowConfirm(false);
    }

    const close = () => {
        getContactAffiliatePicker()?.close();
    }

    const toggling = () => setIsOpen(!isOpen);
    const onOptionClicked = (name, id) => () => {
        setSelectedOption(name);
        setIsOpen(false);
        setNewAffiliateId(id);
    };
    return (
        <Fragment>
            <dialog
                id="contactAffiliatePicker"
                className="affiliate-picker-dialog"
                data-article-number=""
            >
                <form method="dialog">
                    <div className="affiliate-picker">
                        <a
                            onClick={() => close()}
                            className="affiliate-picker__close"
                        >
                            <Close />
                        </a>
                        {showConfirm ? (
                            <div className="affiliate-picker__info">
                                    <h2 className="affiliate-picker__header">
                                        {error ?
                                            translate('code.error.contactaffiliate') :
                                            translate('code.confirm.contactaffiliate')
                                        }
                                    </h2>
                                    <p className="affiliate-picker__info-text">
                                        {error ? 
                                         translate('code.confirm.error.contactaffiliate') :
                                         translate('code.confirm.text.contactaffiliate' )
                                         }
                                    </p>
                                    <button
                                        onClick={() => closeConfirmation()}
                                        className="button--outlined button"
                                    >
                                        {translate(
                                            'code.info.button.contactaffiliate'
                                        )}
                                    </button>
                                </div>
                        ) : (
                            showInfo ? (
                                <div className="affiliate-picker__info">
                                    <h2 className="affiliate-picker__header">
                                        {translate(
                                            'code.info.contactaffiliate'
                                        )}
                                    </h2>
                                    <p className="affiliate-picker__info-text">
                                        {translate(
                                            'code.info.text.contactaffiliate'
                                        )}
                                    </p>
                                    <button
                                        onClick={() => setShowInfo(!showInfo)}
                                        className="button--outlined button"
                                    >
                                        {translate(
                                            'code.info.button.contactaffiliate'
                                        )}
                                    </button>
                                </div>
                            ) : (
                                <Fragment>
                                    <h2 className="affiliate-picker__header">
                                        {translate(
                                            'code.affiliate.contactaffiliate'
                                        )}
                                    </h2>
                                    <div className="affiliate-picker__form-select">
                                        <a onClick={toggling}>
                                            <div className="affiliate-picker__form-select--header">
                                                {selectedOption ||
                                                    affiliates[0].name}
                                                {!isOpen ? (
                                                    <ArrowDown className="affiliate-picker__form-select--header-svg" />
                                                ) : (
                                                    <ArrowUp className="affiliate-picker__form-select--header-svg" />
                                                )}
                                            </div>
                                        </a>
                                        {isOpen && (
                                            <div className="affiliate-picker__form-select--container">
                                                <ul className="affiliate-picker__form-select--list">
                                                    {affiliates.map(
                                                        (option, index) => (
                                                            <li
                                                                className="affiliate-picker__form-select--list--item"
                                                                key={index}
                                                                onClick={onOptionClicked(
                                                                    option.name,
                                                                    option.id
                                                                )}
                                                                value={option.id}
                                                            >
                                                                {option.name}
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
    
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleChange(selectedOption);
                                        }}
                                        className="button--outlined button affiliate-picker__button"
                                    >
                                        {translate(
                                            'code.affiliate.button.contactaffiliate'
                                        )}
                                    </button>
                                    <div className="affiliate-picker-info-link-container">
                                        <a
                                            className="affiliate-picker-info-link"
                                            onClick={() => setShowInfo(!showInfo)}
                                        >
                                            {translate(
                                                'code.info.link.contactaffiliate'
                                            )}
                                        </a>
                                    </div>
                                </Fragment>
                            )
                        )}
                    </div>
                </form>
            </dialog>
        </Fragment>
    );
};
export default ContactAffiliatePickerDialog;
